import { Dispatch, SetStateAction } from 'react';

import './TextAreaAnimated.scss';

interface TextAreaAnimatedProps {
  className?: string;
  placeholder: string;
  value: string;
  setState: Dispatch<SetStateAction<string>>;
}

function TextAreaAnimated({ className, placeholder, value, setState }: TextAreaAnimatedProps) {
  return (
    <div className={`custom-textarea-container ${className}`}>
      <textarea placeholder=" " value={value} onChange={e => setState(e.target.value)} />
      <div className="placeholder">{placeholder}</div>
    </div>
  );
}

export default TextAreaAnimated;
